<div [formGroup]="form">
    <div class="row">
        <div class="col-8"></div>
        @if (!isNew) {
            <div class="col-4">
                <button
                    class="btn btn-success btn-action pull-right"
                    [disabled]="!isFormValid()"
                    type="button"
                    bcClick
                    (clicked)="save()"
                >
                    {{ "General.Save" | translate }}
                </button>
                <button
                    class="btn btn-danger btn-action pull-right mr-1"
                    type="button"
                    bcClick
                    (clicked)="cancel()"
                >
                    {{ "General.Cancel" | translate }}
                </button>
            </div>
        }
    </div>
    <div class="row mt-2">
        <div class="col-8">
            <div class="card-text">
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.SessionName" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <input
                            class="form-control"
                            type="text"
                            hznTestId="session-name"
                            formControlName="name"
                            maxlength="160"
                        />
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.SessionDescription" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <textarea
                            rows="2"
                            class="form-control"
                            hznTestId="session-description"
                            formControlName="description"
                            maxlength="4000"
                        ></textarea>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.Club" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <app-club-select hznTestId="session-club"
                            (clubChanged)="onClubChanged($event)"
                            [selectedClubId]="form.controls.clubId.value"
                            [clubs]="context.clubs"
                        ></app-club-select>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded"></div>
                    <div class="col-sm-5">
                        <input
                            class="form-control"
                            type="text"
                            formControlName="capacity"
                            type="number"
                            min="0"
                            step="1"
                            max="9999"
                            numbersOnly="9999"
                        />
                    </div>
                    <div class="col-sm-5">
                        <input
                            type="checkbox"
                            name="isUnlimited"
                            [checked]="!this.form.controls.capacity.value"
                            (change)="unlimitedClicked($event.target.checked)"
                        />
                        {{ "CampDetails.Unlimited" | translate }}
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.TimeRangeVariant" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <select
                            (change)="changeVariant($event.target.value)"
                            class="form-control"
                        >
                            @for (
                                variant of context.timeVariants;
                                track variant
                            ) {
                                <option
                                    [value]="variant"
                                    [selected]="
                                        form.controls.timeRangeVariant.value ==
                                        variant
                                    "
                                >
                                    {{ translateVariant(variant) }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.AgeRange" | translate }}
                    </div>
                    <div class="col-sm-5">
                        <app-age-picker
                            hznTestId="session-age-from"
                            formControlName="ageRangeFromInMonths"
                            [maxAge]="240"
                        ></app-age-picker>
                    </div>
                    <div class="col-sm-5">
                        <app-age-picker
                            hznTestId="session-age-to"
                            formControlName="ageRangeToInMonths"
                            [maxAge]="240"
                        ></app-age-picker>
                    </div>

                    <i
                        class="fa fa-info-circle"
                        placement="right"
                        aria-hidden="true"
                        [tooltip]="ageRangeTooltip"
                        container="body"
                    >
                    </i>

                    <ng-template #ageRangeTooltip
                        >{{ "CampDetails.AgeRangeExplanation" | translate }}
                    </ng-template>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.EffectiveAgeRange" | translate }}
                    </div>

                    @if (ageChange) {
                        <div class="col-sm-5">
                            <input
                                type="number"
                                class="form-control"
                                formControlName="ageRangeFromInMonthsEffective"
                                min="0"
                                step="1"
                                max="252"
                                numbersOnly="252"
                            />
                        </div>
                    }
                    @if (ageChange) {
                        <div class="col-sm-5">
                            <input
                                type="number"
                                class="form-control"
                                formControlName="ageRangeToInMonthsEffective"
                                min="0"
                                step="1"
                                max="252"
                                numbersOnly="252"
                            />
                        </div>
                    }

                    @if (!ageChange) {
                        <div class="col-sm-8">
                            <span>
                                {{
                                    form.controls.ageRangeFromInMonthsEffective
                                        .value
                                }}
                                -
                                {{
                                    form.controls.ageRangeToInMonthsEffective
                                        .value
                                }}
                                months
                            </span>
                            <button
                                class="btn btn-primary btn-action ml-3"
                                type="button"
                                (click)="toggleAgeChange()"
                            >
                                Override
                            </button>
                        </div>
                    }
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.TimeVariantPrice" | translate }}
                    </div>
                    <div class="col-sm-5">
                        <app-amount-picker
                            [isRequired]="true"
                            hznTestId="session-base-price"
                            name="basePrice"
                            formControlName="basePrice"
                        >
                        </app-amount-picker>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.TimeVariantTimeRange" | translate }}
                    </div>
                    <div class="col-sm-5">
                        <bcui-time-picker
                            hznTestId="session-time-from"
                            formControlName="timeFromInMinutes"
                        ></bcui-time-picker>
                    </div>
                    <div class="col-sm-5">
                        <bcui-time-picker
                            hznTestId="session-time-to"
                            formControlName="timeToInMinutes"
                        ></bcui-time-picker>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{
                            "CampDetails.AllowCustomVariantSelection"
                                | translate
                        }}
                    </div>
                    <div class="col-sm-5">
                        <ui-switch
                            [checked]="
                                form.controls.allowCustomVariantSelection.value
                            "
                            (change)="onCustomVariantAllowedChange($event)"
                            class="switch"
                            size="small"
                            color="#346ABC"
                            switchColor="white"
                        ></ui-switch>
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{
                            "CampDetails.AllowCampCreditPointsUsage" | translate
                        }}
                    </div>
                    <div class="col-sm-5">
                        <ui-switch
                            [checked]="
                                form.controls.allowCampCreditPointsUsage.value
                            "
                            (change)="onCreditPointsUsageAllowedChange($event)"
                            class="switch"
                            size="small"
                            color="#346ABC"
                            switchColor="white"
                        ></ui-switch>
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.PhoneNumber" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <input
                            class="form-control"
                            type="text"
                            formControlName="contactPhone"
                        />
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.Email" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <input
                            class="form-control"
                            type="text"
                            formControlName="contactEmail"
                        />
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-sm-2 bolded">
                        {{ "CampDetails.WorkingHours" | translate }}
                    </div>
                    <div class="col-sm-10">
                        <textarea
                            class="form-control"
                            formControlName="contactWorkingHours"
                            maxlength="200"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <app-session-days hznTestId="session-days"
                [form]="sessionDaysForm"
                [readonly]="false"
            ></app-session-days>
        </div>
    </div>
</div>
